import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import React, { useContext, useEffect, useState } from "react"
import { View } from "react-native"
import { CustomTab } from "@Components/CustomTab/CustomTab"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { GoalService } from "@Services/Goals.Service"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { message } from "@Constants/constant"
import { ActivityIndicator } from "react-native-paper"
import { useRecoilValue } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"
import { needUpdateGoalAtom } from "@Recoil/Atom/goalAtom"
import { CurrentGoals } from "./CurrentGoals"
import { GoalContext } from "@Providers/GoalProvider"
import { uniqBy } from "lodash"
import { UniqByKeyValues } from "@Utils/utils"

export const Goals = ({ navigation }) => {
    const user = useRecoilValue(userAtom)
    const running = "En cours"
    const done = "Terminé"
    const [currentScreen, setCurrentScreen] = useState(running)
    const [patientGoals, setPatientGoals] = useState([])
    const [goals, setGoals] = useState([])
    const [loading, setLoading] = useState(false)
    const needUpdateGoal = useRecoilValue(needUpdateGoalAtom)
    const { updateGoals } = useContext(GoalContext)

    const fetchPatientGoals = () => {
        setLoading(true)
        GoalService.GetPatientGoals(user?.id)
            .then((response) => {
                const data = response.data?.data?.skills
                if (data && data instanceof Array) {
                    setPatientGoals(data)
                }
                setLoading(false)
            })
            .catch((e) => {
                console.log({ patientGoals: e })
                setLoading(false)
                ShowToast({ type: "error", message: message.serverError })
            })
    }

    const fetchGoals = () => {
        setLoading(true)
        GoalService.GetGoals(user?.id)
            .then((response) => {
                const data = response.data?.data
                setGoals(data)
                setLoading(false)
            })
            .catch((e) => {
                setLoading(false)
                ShowToast({ type: "error", message: message.serverError })
            })
    }

    useEffect(() => {
        fetchPatientGoals()
    }, [needUpdateGoal, updateGoals])

    useEffect(() => {
        fetchGoals()
    }, [])

    const allGoals = patientGoals?.flatMap((skill) => skill?.goals)
    const allGoalsWithTrimedName = allGoals?.map((goal) => ({
        ...goal,
        trimedName: goal?.name?.trim()?.toLowerCase()
    }))
    const removeDuplicateGoals = UniqByKeyValues({ items: allGoalsWithTrimedName, key: "trimedName" })

    const inProgressGoals = removeDuplicateGoals?.filter(
        (item) => item?.state?.name === running && item?.numValidated !== item?.numTimeValidation
    )

    const doneGoals = removeDuplicateGoals?.filter(
        (item) => item?.state?.name === done || item?.numValidated === item?.numTimeValidation
    )

    return (
        <ContainerStackScreen>
            <CustomScrollview>
                <Spacer height={15} />
                <BreeSerifText color={baseColors.green.primary} fontSize={24}>
                    Mes objectifs
                </BreeSerifText>

                <Spacer height={15} />

                <OpenSansText fontSize={16}>
                    Découvrez tous vos objectifs : ceux en cours ou à venir et ceux que vous avez réussis !
                </OpenSansText>

                <Spacer height={15} />

                <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                    <CustomTab
                        currentScreen={currentScreen}
                        onPress={() => setCurrentScreen(running)}
                        title={running}
                        value={running}
                    />
                    <CustomTab
                        value={done}
                        currentScreen={currentScreen}
                        onPress={() => setCurrentScreen(done)}
                        title="Passés"
                    />
                </View>

                {loading ? (
                    <ActivityIndicator size={"large"} color={baseColors.green.primary} style={{ padding: 30 }} />
                ) : currentScreen === running ? (
                    <CurrentGoals
                        skills={patientGoals}
                        patientGoals={inProgressGoals}
                        goalSkills={goals}
                        navigation={navigation}
                    />
                ) : (
                    <CurrentGoals
                        isDone
                        skills={patientGoals}
                        patientGoals={doneGoals}
                        goalSkills={goals}
                        navigation={navigation}
                    />
                )}
            </CustomScrollview>
        </ContainerStackScreen>
    )
}
